import { useLazyRetrieveCustomerDidsQuery } from "@/react/features/smp/dms/didApi";
import { useCallback } from "react";
import { DID_STATUS } from "@/react/features/smp/dms/constants";

export const useCustomerNumberSearch = () => {
  const [retrieveCustomerDids, { data: dids, isFetching }] =
    useLazyRetrieveCustomerDidsQuery();

  const searchDids = useCallback(
    (searchQuery) => {
      const filterOpts = {
        opts: {
          status: [DID_STATUS.AVAILABLE],
        },
      };

      if (searchQuery) {
        filterOpts.opts.phoneNumber = [`*${searchQuery.replace("+", "")}*`];
      }

      return retrieveCustomerDids(
        {
          filterOpts,
          params: { size: 10 },
        },
        true
      ).then((result) => result.data || []);
    },
    [retrieveCustomerDids]
  );

  return {
    dids,
    searchDids,
    isFetching,
  };
};
